import request from '@/utils/request';

export class ExternalSystemApiSerivce {
  static getK3cloudUrl(data: { userName: string }) {
    return request.get('/passport/api/k3cloud', data);
  }
}
